// Tie Types
export const TIE_TYPE_PRE_TIED = 'Pre Tied' as const;
export const TIE_TYPE_SELF_TIED = 'Self Tied' as const;

export const TieTypes = [TIE_TYPE_PRE_TIED, TIE_TYPE_SELF_TIED];
